module.exports = __webpack_public_path__ + "static/media/vendor-bg.4b064376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vendor-bg.jpg
// module id = 715
// module chunks = 21